import { PlanManagementList } from './PlanManagementList';

export default PlanManagementList;